import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    // list of supported locales
    locales: ['de'],

    // default locale which is used when no locale matches
    defaultLocale: 'de',

    // we do not want to use a locale cookie
    localeCookie: false
});

export type Locale = (typeof routing.locales)[number];
